import reducer from "./reducer";
export { default as TaxTable } from "./components/index";
export { default as taxTableReducerName } from "./constants";
export default reducer;
